import { Box, Stack } from "@mui/system";
import BLDWebsiteIncomeCard from "./BLDWebsiteIncomeCard";

const BLDWebsiteIncome = () => {
  return (
    <>
      <Box>
        <Stack spacing={2}>
          <BLDWebsiteIncomeCard
            date="13/12/2025"
            totalIncome="$36,781"
            cpa="$29,116"
            cpaPercentage="79%"
            cpaColor="success"
            rs="$6,689"
            rsPercentage="23%"
            rsColor="error"
            profit="-$13,919"
          />
          <BLDWebsiteIncomeCard
            date="12/12/2025"
            totalIncome="$71,602"
            cpa="$48,877"
            cpaPercentage="68%"
            cpaColor="success"
            rs="$21,277" 
            rsPercentage="32%"
            rsColor="error"
            profit="$14,811"
          />
          <BLDWebsiteIncomeCard
            date="11/12/2025"
            totalIncome="$42,422"
            cpa="$32,419"
            cpaPercentage="76%"
            cpaColor="success"
            rs="$10,673"
            rsPercentage="24%"
            rsColor="error"
            profit="$14,811"
          />
        </Stack>
      </Box>
    </>
  );
};

export default BLDWebsiteIncome;
